import React from 'react';
import Link from 'next/link';
import SupportIcon from '@components/SupportSection/shared/SupportIcon';
import SupportHomeStyles from '@/components/SupportSection/SupportHome/SupportHomeStyles';
import useMediaQuery from '@/helpers/hooks/useMediaQuery';
import SearchBar from '../shared/SearchBar';

const SupportHome = ({ data }) => {
  const {
    hero_title,
    hero_image,
    business_needs,
  } = data;

  const isMobile = useMediaQuery('(max-width: 576px)');

  return (
    <SupportHomeStyles>
      <div className="header-container">
        <div className="hero-title-container">
          <div className="hero-title">
            {hero_title}
          </div>
        </div>
        <div className="hero-container">
          <img className="hero-image" src={hero_image} alt="hero-image" />
          <div className="input-container">
            <SearchBar />
          </div>
        </div>
      </div>
      <div className="content-wrapper">
        <div className="popular-container">
          <div className="popular-title-container">
            <img src="/icons/trending-up.svg" />
            <div className="popular-title">
              Popular
            </div>
          </div>
          <div className="popular-links-container">
            <div className="link-wrapper">
              <Link href="/support/return-status">
                <a className="link">Check My Tax Return Status</a>
              </Link>
            </div>
            <div className="link-wrapper">
              <Link href="/support/appointment">
                {isMobile ?
                  <a className="link">Schedule an Appointment</a> :
                  <a className="link">Schedule an Appointment with Your Accounting Team</a>
                }
              </Link>
            </div>
            <div className="link-wrapper">
              <Link href="/support/billing">
                <a className="link">Request Billing Support</a>
              </Link>
            </div>
          </div>
          <div className="all-sections-container">
            <div className="all-sections-title">
              All Sections
            </div>
            <div className="icons-container">
              {business_needs.map(element => (
                <SupportIcon data={element} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </SupportHomeStyles>
  );
};

export default SupportHome;